module.exports = __webpack_public_path__ + "img/PR.9f8f231a.png";